import { AbstractAppService } from "@shopliftr/common-ng";
import {
    Injectable, inject
} from "@angular/core";
import { AppRouterService } from "./app-router.service";
import { IAppConfig } from "../interfaces/app-config";
import { APP_CONFIG } from "../constants/app-config-token";

/**
 * The Application service manages the global state of the partner application.
 * For example processing or fullscreen state.
 *
 * This is provided in app.options.ts for this application.
 *
 * Can be injected directly:
 * ```
 * readonly appState = inject(AppService);
 * ```
 * @see AbstractAppService
 */
@Injectable()
export class AppService extends AbstractAppService<IAppConfig, AppRouterService> {

    /**
     * Configuration for the Partner application.
     */
    readonly config = inject(APP_CONFIG);

    /**
     * The app router service for the Partner application.
     */
    readonly appRouter = inject(AppRouterService);
}
